// Testimonial images
import Alannah from 'assets/images/review-avatars/alannah.svg';
import Austin from 'assets/images/review-avatars/austin.svg';
import Casey from 'assets/images/review-avatars/casey.svg';
import Constance from 'assets/images/review-avatars/constance.svg';
import Fern from 'assets/images/review-avatars/fern.svg';
import Lee from 'assets/images/review-avatars/lee.svg';
import Leila from 'assets/images/review-avatars/leila.svg';
import Matthew from 'assets/images/review-avatars/matthew.svg';
import Melanie from 'assets/images/review-avatars/melanie.svg';
import Millie from 'assets/images/review-avatars/millie.svg';
import Mitchell from 'assets/images/review-avatars/mitchell.svg';
import Rahul from 'assets/images/review-avatars/rahul.svg';
import Raphael from 'assets/images/review-avatars/raphael.svg';
import Robin from 'assets/images/review-avatars/robin.svg';
import Stanley from 'assets/images/review-avatars/stanley.svg';
import Tanya from 'assets/images/review-avatars/tanya.svg';
import Tony from 'assets/images/review-avatars/tony.svg';

const randomNumber = () => Math.floor(Math.random() * 14) + 1;

export const reviews = [
  {
    name: 'Leila C.',
    city: 'Seattle',
    days: randomNumber(),
    img: Leila,
    dimensions: {
      width: '100',
      height: '107',
    },
    review:
      '"I found a wonderful dentist with a great sense of humor. I am a terrible patient and afraid of everything. He checked in with me through the process and I really felt I was in good hands! I have another appointment scheduled!"',
    id: 3,
  },
  {
    name: 'Millie D.',
    city: 'San Francisco',
    days: randomNumber(),
    img: Millie,
    dimensions: {
      width: '100',
      height: '116',
    },
    review:
      '"So welcoming and knowledgeable. Never felt so comfortable at a dentist and he was able to let me know my options right away. 10/10 recommending."',
    id: 4,
  },
  {
    name: 'Melanie E.',
    city: 'Austin',
    days: randomNumber(),
    img: Melanie,
    dimensions: {
      width: '100',
      height: '108',
    },
    review:
      '"It was a great first appointment. She was more than informative for my situation and options. Very kind and easy to express concerns too. The staff was so friendly and kind."',
    id: 5,
  },
  {
    name: 'Tanya F.',
    city: 'San Diego',
    days: randomNumber(),
    img: Tanya,
    dimensions: {
      width: '100',
      height: '113',
    },
    review:
      '"He takes time to listen to your concerns and doesn\'t push any services. He gave me recommendations on how to make my teeth appear better and his staff were great as well. The amenities really add to the experience as well."',
    id: 6,
  },
  {
    name: 'Constance H.',
    city: 'Denver',
    days: randomNumber(),
    img: Constance,
    dimensions: {
      width: '100',
      height: '108',
    },
    review:
      '"I\'m so glad I went through Opencare to find a new dentist. Very satisfied! I have been in need of a new dentist for a year and Opencare made the process very simple."',
    id: 7,
  },
  {
    name: 'Alannah I.',
    city: 'San Jose',
    days: randomNumber(),
    img: Alannah,
    dimensions: {
      width: '100',
      height: '112',
    },
    review:
      '"I was wowed literally from the moment I walked in! I felt comfortable and at ease every moment of the way, and loved that they talked to me on a very real level. Also, thanks for not shaming me for not flossing :)"',
    id: 8,
  },
  {
    name: 'Fern L.',
    city: 'Denver',
    days: randomNumber(),
    img: Fern,
    dimensions: {
      width: '100',
      height: '109',
    },
    review:
      '"Everyone was very nice, courteous, and attentive to the needs of the patient. The office space itself is extremely nice, including massage chairs."',
    id: 10,
  },
  {
    name: 'Robin V.',
    city: 'Chicago',
    days: randomNumber(),
    img: Robin,
    dimensions: {
      width: '100',
      height: '109',
    },
    review:
      '"Super friendly staff, very professional but approachable. The office is easy to find and comfortable. Everything was explained really well and all my questions were answered. Overall fantastic experience!"',
    id: 12,
  },
  {
    name: 'Lee G.',
    city: 'Austin',
    days: randomNumber(),
    img: Lee,
    dimensions: {
      width: '100',
      height: '113',
    },
    review:
      '"I think I have found a permanent dentist. Everyone in his office is so nice and explained every part of my appointment very thoroughly. Made me feel completely comfortable."',
    id: 13,
  },
  {
    name: 'Casey N.',
    city: 'Seattle',
    days: randomNumber(),
    img: Casey,
    dimensions: {
      width: '100',
      height: '101',
    },
    review:
      '"Everyone was great. All the staff were pleasant. They took my son in and worked on his teeth. They kept talking to my son so he doesnt get nervous. My son had a great time. I would definitely recommend them."',
    id: 14,
  },
  {
    name: 'Austin O.',
    city: 'San Jose',
    days: randomNumber(),
    img: Austin,
    dimensions: {
      width: '100',
      height: '112',
    },
    review:
      '"Literally the best dental visit l have ever had. As someone who has had a challenging dental history and  very sensitive teeth,  it\'s obvious that everyone at this practice is kind and truly cares."',
    id: 15,
  },
  {
    name: 'Tony P.',
    city: 'Chicago',
    days: randomNumber(),
    img: Tony,
    dimensions: {
      width: '100',
      height: '101',
    },
    review:
      '"Everyone was kind and caring. Process was hassle free. The dental hygienist took the extra time not to hurt me. It was less painful than my previous cleanings."',
    id: 16,
  },
  {
    name: 'Stanley R.',
    city: 'Seattle',
    days: randomNumber(),
    img: Stanley,
    dimensions: {
      width: '100',
      height: '102',
    },
    review:
      '"My dentist was super friendly and thorough in explaining EXACTLY what was going on with my teeth while continually checking that I was comfortable. Best dental experience I\'ve had."',
    id: 17,
  },
  {
    name: 'Raphael S.',
    city: 'San Diego',
    days: randomNumber(),
    img: Raphael,
    dimensions: {
      width: '100',
      height: '107',
    },
    review:
      '"Easy to check in. Doctor was considerate while cleaning the teeth. Provided helpful suggestions after the appointment. Will recommend to everyone."',
    id: 18,
  },
  {
    name: 'Mitchell T.',
    city: 'Denver',
    days: randomNumber(),
    img: Mitchell,
    dimensions: {
      width: '100',
      height: '116',
    },
    review:
      '"The clinic was great. They had really nice equipment that gave me an all around image of my teeth and my overall dental health. They were very friendly and had music playing softly in the background which I really appreciated!"',
    id: 19,
  },
  {
    name: 'Matthew W.',
    city: 'Austin',
    days: randomNumber(),
    img: Matthew,
    dimensions: {
      width: '100',
      height: '108',
    },
    review:
      '"It was a really good experience. The place is super neat and clean, the staff is really friendly and professional. I did not have to wait a minute and overall it was an excellent experience. I will definitely come back!!"',
    id: 20,
  },
  {
    name: 'Rahul K.',
    city: 'Toronto',
    days: randomNumber(),
    img: Rahul,
    dimensions: {
      width: '100',
      height: '115',
    },
    review:
      '"Dental clinic is very clean & equipment seems very new! The reception staff is friendly and welcoming. Bonus is that you can watch Netflix during the appointment!!"',
    id: 21,
  },
];

// Refer to https://www.notion.so/opencare/Results-Page-Configuration-bea2efa1f74e4a61acc4dbb056d6dc4b?pvs=4
// This array should be in sync with the Notion doc at all times
const matchResultsPageConfigurations = [
  {
    id: 1,
    createdAt: '2023-08-28',
    description: 'Initial Configuration',
  },
  {
    id: 2,
    createdAt: '2023-09-07',
    description: 'Added Reviews in Match Results as A/B Experiment',
  },
  {
    id: 3,
    createdAt: '2023-09-20',
    description:
      'Added Redesigned Match Result Cards as A/B Experiment in Illinois',
  },
  {
    id: 4,
    createdAt: '2023-11-06',
    description: 'Full-timed Reviews Experiment',
  },
  {
    id: 5,
    createdAt: '2023-11-16',
    description: 'Full-timed Redesigned Match Result Cards Experiment',
  },
];

// Update the index to the new configuration when it's added. Keep the old configurations for historical purposes.
export const getMatchResultsPageConfiguration = () =>
  matchResultsPageConfigurations[5 - 1];
